import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { type FC } from "react";
import { type Control, Controller } from "react-hook-form";

interface ValueInputButtonProps {
  control?: Control<any>;
  rules?: Record<string, unknown>;
  name: string;
  isLoading?: boolean;
  onOpenModal: (value: string | null) => void;
  onDeleteItem: () => void;
  disabled?: boolean;
}

const ValueInputButton: FC<ValueInputButtonProps> = ({
  control,
  rules,
  name,
  isLoading = false,
  onOpenModal,
  onDeleteItem,
  disabled,
}) => {
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ field: { value } }) => (
        <>
          {value ? (
            <div className="flex items-center text-gray-700">
              <span>{value}</span>
              {!disabled && (
                <div className="ml-3 flex items-center">
                  <PencilSquareIcon
                    className="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-900"
                    onClick={() => {
                      onOpenModal(value);
                    }}
                  />
                  <TrashIcon
                    className="h-5 w-5 cursor-pointer text-gray-500 hover:text-red-500"
                    onClick={onDeleteItem}
                  />
                </div>
              )}
            </div>
          ) : (
            <button
              className="inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              onClick={() => {
                onOpenModal(null);
              }}
              disabled={isLoading || disabled}>
              Enter Value
            </button>
          )}
        </>
      )}
    />
  );
};

export default ValueInputButton;
